import React from 'react';

export function PlusIcon() {
  // https://lucide.dev/icons/plus
  return (
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14" />
      <path d="M12 5v14" />
    </g>
  );
}
